import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Link, useNavigate } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import { debounce } from "@mui/material";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import { validatePermission } from "../../../utils/permissionUtils";
import { usePermissions } from "../../../context/permissionContext";
import Loader from "../../../components/Loader/Loader";
import { CircularProgressbar } from "react-circular-progressbar";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import "react-circular-progressbar/dist/styles.css";
import "../../../components/common/css/datatable.scss";

const Inventmelist = () => {
  const [query, setQuery] = useState("");
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [pageState, setPageState] = useState({
    data: [],
    total: 0,
    page: 1,
    pageSize: 9,
  });

  const { permissions, permissionsMapping } = usePermissions();

  const handleQuery = useCallback(
    debounce((e) => {
      setQuery(e.target.value);
      setPageState({ ...pageState, page: 1 });
    }, 1000)
  );

  const fetchuserData = () => {
    const token = localStorage.getItem("accessToken");
    setLoading(true);
    setPageState((old) => ({ ...old }));
    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "admin/invent-me/in-review-articles",
      headers: {
        "x-access-token": token,
      },
      data: {
        page: pageState.page,
        limit: pageState.pageSize,
        searchTerm: query,
        status: status,
      },
    };

    axios(config)
      .then(function (response) {
        setLoading(false);

        setPageState((old) => ({
          ...old,
          data: response.data.data.rows,
          total: response.data.data.count,
        }));
      })
      .catch(function (error) {
        setLoading(false);
        Swal.fire({
          title: error?.response?.data?.message,
          timerProgressBar: true,
          icon: "error",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
      });
  };

  useEffect(() => {
    fetchuserData();
  }, [pageState.page, pageState.pageSize, query, status]);

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 120,
      renderCell: (params) => {
        const hasDeletePermission = validatePermission(
          "InventMe Management:Edit",
          permissions,
          permissionsMapping
        );
        return (
          <div className="cellAction">
            <Link
              to={`/inventme/${params.row.id} `}
              style={{ textDecoration: "none" }}
            >
              <div className="viewButton">
                <RemoveRedEyeOutlinedIcon />
              </div>
            </Link>

            {hasDeletePermission && (
              <div
                className="deleteButton"
                onClick={() => deleteFunction(params?.row?.id)}
              >
                <DeleteOutlineIcon />
              </div>
            )}
          </div>
        );
      },
    },
  ];

  const userColumns = [
    { field: "id", headerName: "ID", width: 70 },

    {
      field: "title",
      headerName: "Tittle",
      width: 150,
    },
    {
      field: "likeCounter",
      headerName: "Likes",
      width: 150,
    },
    {
      field: "disLikeCounter",
      headerName: "DisLikes",
      width: 150,
    },
    {
      field: "viewCounter",
      headerName: "Views",
      width: 150,
    },
    {
      field: "article_category.category_name",
      headerName: "Category",
      width: 170,
      renderCell: (params) => {
        return (
          <div className="rowitem">
            {params?.row?.article_category?.category_name}
          </div>
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      width: 170,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            <span
              className={`status ${
                params.row.status == 1
                  ? "Pending"
                  : params.row.status == 2
                  ? "Approved"
                  : params.row.status == 3
                  ? "Rejected"
                  : params.row.status == 4
                  ? "Inreview"
                  : "Draft"
              }`}
            >
              {params?.row?.status == 1
                ? "Pending"
                : params?.row?.status == 2
                ? "Published"
                : params?.row?.status == 3
                ? "Rejected"
                : params?.row?.status == 4
                ? "In-Review"
                : "Draft"}
            </span>
          </div>
        );
      },
    },
    {
      field: "updatedAt",
      headerName: "Last Updated",
      width: 150,
      renderCell: (params) => {
        const d = new Date(params?.row?.updatedAt);
        return (
          <>
            <div className="rowitem">{d.toDateString()}</div>
          </>
        );
      },
    },
  ];
  const deleteFunction = (id) => {
    // console.log("idddd", id);
    const token = localStorage.getItem("accessToken");
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this user!",
      icon: "warning",
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios
          .delete(process.env.REACT_APP_API + `admin/invent-me/article/${id}`, {
            headers: {
              "x-access-token": token,
            },
          })
          .then(function (response) {
            if (response?.data?.status == 200) {
              setLoading(false);
              fetchuserData();
            }
          })
          .catch(function (error) {
            setLoading(false);
            Swal.fire({
              title: error?.response?.data?.message,
              timerProgressBar: true,
              icon: "error",
              confirmButtonText: "OK",
              showCloseButton: true,
            });
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        setLoading(false);
        Swal.fire("Cancelled", "User is not deleted", "error");
      }
    });
  };
  return (
    <div className="datatable">
      <Loader isLoading={loading} />
      <div className="datatableTitle">
        <div className="tablesearch">
          <input type="text" placeholder="Search..." onChange={handleQuery} />
          <SearchOutlinedIcon className="sarchicon" />
        </div>
        <h5 style={{ marginLeft: "-10%" }}>InventMe</h5>
        <div className="formInput">
          <select name="filter" onChange={(e) => setStatus(e.target.value)}>
            <option value="" disabled selected hidden>
              Select Status
            </option>
            <option value={1}>Pending</option>
            <option value={2}>Published</option>
            <option value={3}>Rejected</option>
            <option value={4}>In Review</option>
            <option value="">All</option>
          </select>
        </div>
      </div>
      <DataGrid
        className="datagrid"
        autoHeight
        rows={pageState.data}
        rowCount={pageState.total}
        rowsPerPageOptions={[10, 30, 50, 70, 100]}
        pagination
        page={pageState.page - 1}
        pageSize={pageState.pageSize}
        paginationMode="server"
        onPageChange={(newPage) => {
          setPageState((old) => ({ ...old, page: newPage + 1 }));
        }}
        onPageSizeChange={(newPageSize) =>
          setPageState((old) => ({ ...old, pageSize: newPageSize }))
        }
        columns={userColumns.concat(actionColumn)}
      />
    </div>
  );
};

export default Inventmelist;
